<div
  bsModal
  #archiveListModal="bs-modal"
  [config]="{
    show: false,
    keyboard: !modalControl.isSaving,
    ignoreBackdropClick: modalControl.isSaving
  }"
  [rlTrapFocus]="{ setReturnFocus: '#edit-list-btn' }"
  (onHidden)="onHidden()"
  class="c-modal modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="archive-list-modal-heading"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <span class="fa-stack fa-5x" aria-hidden="true">
        <i class="fas fa-circle fa-stack-2x icon-bg-danger"></i>
        <i class="fal fa-archive fa-stack-1x text-danger"></i>
      </span>

      <h2
        id="archive-list-modal-heading"
        class="qa-archive-list__heading alpha"
        i18n="@@archiveListModal-heading-archiveList"
      >
        Archive list
      </h2>

      <div
        *ngIf="modalControl.savingError ? true : false"
        class="alert alert-danger qa-archive-list__error"
        role="alert"
      >
        <strong i18n="@@archiveListModal-status-error">Error!</strong>
        <ng-container i18n="@@archiveListModal-status-errorPleaseRetry"
          >There was an error archiving the list. Please try
          again.</ng-container
        >
      </div>

      <p
        id="archive-list-modal-status"
        class="qa-archive-list__status"
        i18n="@@archiveListModal-status-warningCannotBeUndone"
      >
        Warning, archived lists cannot be edited and will not show up in
        searches. You cannot undo this operation.
      </p>

      <div class="c-modal__footer">
        <button
          (click)="onCancel()"
          [disabled]="modalControl.isSaving"
          type="button"
          class="btn btn-default qa-archive__cancel-button"
          i18n="@@archiveListModal-btn-cancel"
        >
          Cancel
        </button>
        <button
          (click)="onConfirm()"
          [disabled]="modalControl.isSaving"
          type="button"
          class="btn btn-danger qa-archive__confirm-button"
        >
          <span
            *ngIf="modalControl.isSaving"
            class="text-center qa-archive__saving"
            role="status"
          >
            <i
              class="fas fa-spinner-third fa-fw fa-spin"
              aria-hidden="true"
            ></i>
            <span class="sr-only" i18n="@@archiveListModal-spinner-saving"
              >Saving...</span
            >
          </span>
          <ng-container i18n="@@archiveListModal-btn-confirm">
            Archive
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
